import { Link } from 'react-router-dom';

const footerLinks = {
  热门分类: [
    { label: '足球赛事', href: '/category/football' },
    { label: '篮球赛事', href: '/category/basketball' },
    { label: '网球赛事', href: '/category/tennis' },
    { label: '电竞赛事', href: '/category/esports' },
    { label: '乒乓球', href: '/category/table-tennis' },
    { label: '羽毛球', href: '/category/badminton' },
  ],
  平台服务: [
    { label: '赛事直播', href: '/category/football' },
    { label: '数据分析', href: '/category/basketball' },
    { label: '赛事预测', href: '/category/tennis' },
    { label: '专家推荐', href: '/category/esports' },
    { label: 'VIP 会员', href: '/about' },
  ],
  关于我们: [
    { label: '品牌介绍', href: '/about' },
    { label: '联系我们', href: '/about' },
    { label: '用户协议', href: '/about' },
    { label: '隐私政策', href: '/about' },
    { label: '常见问题', href: '/about' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-background-950 text-foreground-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-basketball-line text-xl text-white"></i>
              </div>
              <span className="font-heading text-xl font-bold text-white whitespace-nowrap">
                好博体育
              </span>
            </div>
            <p className="text-sm text-foreground-300 leading-relaxed">
              好博体育是领先的专业体育竞技娱乐平台，汇聚全球顶级赛事资源，
              为广大体育爱好者打造极致的赛事体验平台。
            </p>
            <div className="flex gap-3 mt-5">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-primary-500 transition-colors" aria-label="微信">
                <i className="ri-wechat-line text-white"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-primary-500 transition-colors" aria-label="微博">
                <i className="ri-weibo-line text-white"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-primary-500 transition-colors" aria-label="QQ">
                <i className="ri-qq-line text-white"></i>
              </a>
            </div>
          </div>

          {Object.entries(footerLinks).map(([title, links]) => (
            <div key={title}>
              <h4 className="font-heading text-base font-semibold text-white mb-4">
                {title}
              </h4>
              <ul className="space-y-2.5">
                {links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.href}
                      className="text-sm text-foreground-300 hover:text-primary-400 transition-colors whitespace-nowrap"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-foreground-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; {new Date().getFullYear()} 好博体育 版权所有 | 好博体育官网 haobo-sports.com
          </p>
          <div className="flex items-center gap-4">
            <a href="/about" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">用户协议</a>
            <a href="/about" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">隐私政策</a>
            <a href="/about" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}